module.exports = {
	"articleTitle1": "Best of Ann Arbor: Best Chinese Food",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "China Gate",
	"articleLink1": "https://www.michigandaily.com/content/best-ann-arbor-best-chinese-food",
	"articleLink2": "https://www.michigandaily.com/arts/best-ann-arbor-2013-list",
	"articleSnippet1": "Apr 10, 2007 ... Chef Jan's noble visage has since inexplicably disappeared from the front \nwindow of the China Gate Restaurant, but his legend lingers on.",
	"articleSnippet2": "Apr 17, 2013 ... Best Chinese Food Winner: China Gate Runner-up: Lucky Kitchen. Best Late \nNight Winner: Pizza House Runner-up: BTB. Best Landlord",
	"foodRecommendations": [],
	"articleTitle2": "Best of Ann Arbor 2013",
	"address": "1201 S University Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.275199,
		"lng": -83.734431
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/chinagate.json
// module id = 848
// module chunks = 0